const formatDealerName = (dealerName = "") => {
    return dealerName
        .toLowerCase()
        .replace(/[^a-z0-9\s]/g, "") // Remove special characters
        .replace(/\s+/g, "-") // Replace spaces with hyphens
        .replace(/-+/g, "-") // Replace multiple hyphens with single hyphen
        .replace(/^-|-$/g, ""); // Remove leading/trailing hyphens
};

export const getDealerPage = (dealerName = "", dealerId = "") => {
    // Convert dealer name to URL-friendly format
    const urlFriendlyName = formatDealerName(dealerName);
    return `/dealers/${urlFriendlyName}-${dealerId}`;
};

export const getDealerInventoryPage = (dealerName = "", dealerId = "") => {
    const urlFriendlyName = formatDealerName(dealerName);
    return `/dealers/${urlFriendlyName}-${dealerId}/inventory`;
};
